import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ReviewAdjAutomationService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following service pattern exactly
  saveReviewAdj(
    baseUrl: string,
    _data: any[],
    _schdMs: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action code
    const url = `${baseUrl}/saveJsonObject?action_code=g9uv87`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // Build JSON objects exactly like AngularJS service
    const jsonObj = JSON.stringify(_schdMs || []);
    const jsonSettings = JSON.stringify(_data || []);
    
    // Extend with jsonObj and jsonSettings (ensure they take precedence)
    params = _.extend(params, { jsonObj: jsonObj });
    params = _.extend(params, { jsonSettings: jsonSettings });
    
    // 🚀 CRITICAL: Ensure all required fields are present with proper fallbacks
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || globalService?.scenarioCode || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    params.filing_key = filterParams?.filing_key || globalService?.filing_key || rowData?.CONSOL_GROUP_KEY || '1';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || '';

    // 🚀 CRITICAL: Build checkLockedbj from gridData (from _data or _schdMs)
    const checkLockedbj: any[] = [];
    const gridDataArray = _data || _schdMs || [];
    
    if (gridDataArray.length > 0) {
      // Get unique combination keys from the data
      const uniqueCombinations = new Map<string, any>();
      gridDataArray.forEach((item: any) => {
        const combinationKey = String(item.COMBINATION_KEY || '');
        if (combinationKey && !uniqueCombinations.has(combinationKey)) {
          // Store the first item for each unique combination key
          uniqueCombinations.set(combinationKey, item);
        }
      });
      
      // Build checkLockedbj from unique combinations
      uniqueCombinations.forEach((item: any, combinationKey: string) => {
        // Extract LEID and CDR - try multiple possible field names
        const leid = item.LEID || item.leid || rowData?.LEID || filterParams?.leid || '';
        const cdr_number = item.CDR_NO || item.CDR_NUMBER || item.cdr_number || rowData?.CDR_NO || filterParams?.cdr_number || '';
        
        checkLockedbj.push({
          "leid": leid,
          "cdr_number": cdr_number,
          "reporting_period": parseInt(String(item.REPORTING_PERIOD || filterParams?.reporting_period || rowData?.REPORTING_PERIOD || '1')),
          "combination_key": parseInt(combinationKey) || 0,
          "scenario_key": parseInt(filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || '74')
        });
      });
    } else if (rowData && Object.keys(rowData).length > 0) {
      // Fallback to rowData if gridData is not available
      checkLockedbj.push({
        "leid": rowData.LEID || filterParams?.leid || '',
        "cdr_number": rowData.CDR_NO || filterParams?.cdr_number || '',
        "reporting_period": parseInt(String(rowData.REPORTING_PERIOD || filterParams?.reporting_period || '1')),
        "combination_key": parseInt(String(rowData.COMBINATION_KEY || filterParams?.combination_key || '0')),
        "scenario_key": parseInt(filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || '74')
      });
    } else if (filterParams && Object.keys(filterParams).length > 0) {
      // Final fallback to filterParams
      checkLockedbj.push({
        "leid": filterParams?.leid || '',
        "cdr_number": filterParams?.cdr_number || '',
        "reporting_period": parseInt(String(filterParams?.reporting_period || '1')),
        "combination_key": parseInt(String(filterParams?.combination_key || '0')),
        "scenario_key": parseInt(filterParams?.scenario || '74')
      });
    }
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // Set process_name
    params.process_name = "SAVE_REVIEW_ADJ_AUTOMATIONS";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}

